import { render } from "./Or_map.vue?vue&type=template&id=35da82ea&scoped=true&ts=true"
import script from "./Or_map.vue?vue&type=script&lang=ts"
export * from "./Or_map.vue?vue&type=script&lang=ts"

import "./Or_map.vue?vue&type=style&index=0&id=35da82ea&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35da82ea"]])

export default __exports__